module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Listofillustrations#listofillustrations",
      "id": "toc-listofillustrations"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface#preface",
      "id": "toc-preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Principalpersons#principalpersons",
      "id": "toc-principalpersons"
    }
  }, [_vm._v("Principal Persons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Part1#part1",
      "id": "toc-part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")]), _vm._v(": H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORIANS IN THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKING")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter1#chap1",
      "id": "toc-1"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "href": "#/011_Chapter1#chap1"
    }
  }, [_vm._v("Marder: Examining Britannia’s Anatomy")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter2#chap2",
      "id": "toc-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _c('span', {
    attrs: {
      "href": "#/012_Chapter2#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roskill: Guns Ashore and Afloat")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter3#chap3",
      "id": "toc-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _c('span', {
    attrs: {
      "href": "#/013_Chapter3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder’s Admirable Admirals: Richmond and Fisher")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter4#chap4",
      "id": "toc-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _c('span', {
    attrs: {
      "href": "#/014_Chapter4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder: The Ali Baba of Historical Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter5#chap5",
      "id": "toc-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _c('span', {
    attrs: {
      "href": "#/015_Chapter5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roskill and the Politics of Official History")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter6#chap6",
      "id": "toc-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _c('span', {
    attrs: {
      "href": "#/016_Chapter6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marder Ascendant: Swaying Palms, Instant University, and Dreaming Spires")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Part2#part2",
      "id": "toc-part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLISION")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter7#chap7",
      "id": "toc-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _c('span', {
    attrs: {
      "href": "#/018_Chapter7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fight for Hankey’s Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter8#chap8",
      "id": "toc-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _c('span', {
    attrs: {
      "href": "#/019_Chapter8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historians at War: Quarrels over Churchill and Admirals")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter9#chap9",
      "id": "toc-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _c('span', {
    attrs: {
      "href": "#/020_Chapter9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roskill: Refighting Jutland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Part3#part3",
      "id": "toc-part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#chap10",
      "id": "toc-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _c('span', {
    attrs: {
      "href": "#/022_Chapter10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rising Sun and California Sunset: Marder’s Farewell to History")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#chap11",
      "id": "toc-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _c('span', {
    attrs: {
      "href": "#/023_Chapter11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roskill at Churchill College: The Laurels and the Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "list-toc1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Epilogueourhistoricaldreadnoughts#epilogueourhistoricaldreadnoughts",
      "id": "toc-epilogueourhistoricaldreadnoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _c('span', {
    attrs: {
      "href": "#/024_Epilogueourhistoricaldreadnoughts#epilogueourhistoricaldreadnoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Historical Dreadnoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Notes#notes",
      "id": "toc-notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Bibliography#bib",
      "id": "toc-bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Index#ind",
      "id": "toc-ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cce09690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_TOC.vue
// module id = 66
// module chunks = 0